import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { themes } from "@/Components/Styling/themeConfigs";

type Props = {
  title: string;
};

function SectionTitle({ title }: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 12,
    },
    text: {
      fontSize: currentTheme.typography.h1.size.web,
      color: currentTheme.typography.h1.color,
      fontWeight: "600",
      marginLeft: 8,
    },
  });

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{title}</Text>
    </View>
  );
}

export default SectionTitle;
